import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, isMemoSame as _isMemoSame, withMemo as _withMemo } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-row tw-justify-start tw-items-center" }
const _hoisted_2 = { class: "tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58] tw-pr-[19px]" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_4 = { class: "tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]" }
const _hoisted_5 = { class: "tw-p-[15px] tw-w-[475px]" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_11 = { class: "tw-flex tw-flex-row tw-gap-3 tw-ml-[15px]" }
const _hoisted_12 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`complete tw-flex tw-w-full tw-justify-center tw-items-center tw-gap-[5px] tw-rounded-[4px] tw-py-[3px] tw-px-[5px]`)
}
const _hoisted_13 = { class: "tw-text-[#01893D] tw-text-[11px] tw-font-Poppins tw-font-[500]" }
const _hoisted_14 = { class: "tw-w-[12px] tw-h-[12px] tw-inline-flex" }
const _hoisted_15 = {
  class: /*#__PURE__*/_normalizeClass(`exposure tw-flex tw-w-full tw-justify-center tw-items-center tw-gap-[5px] tw-rounded-[4px] tw-py-[3px] tw-px-[5px]`)
}
const _hoisted_16 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-Poppins tw-font-[500]" }
const _hoisted_17 = {
  key: 0,
  class: "tw-p-[25px] tw-pt-0 tw-mt-[1px] tw-bg-[transparent] tw-border-solid tw-border-[1px] tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-[#EFF0F1] tw-rounded-b-[6px]"
}
const _hoisted_18 = { class: "tw-flex tw-items-center tw-justify-between empty-question tw-rounded-[6px] tw-px-[20px] tw-py-[14px]" }
const _hoisted_19 = { class: "tw-m-0 tw-text-[#FE9A05] tw-text-[13px] tw-leading-[145%] tw-font-[400]" }
const _hoisted_20 = { class: "tw-flex tw-flex-col tw-gap-[10px]" }

import { PropType, Ref, computed, onMounted, ref, watch } from "vue";
import circularProgress from "./circularProgress.vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import AssessmentQuestion from "@/components/assessments/assessmentQuestionType2.vue";
import store from "@/store";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  assessmentQuestionAnswerType,
  assessmentQuestionVisibleState,
} from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { IAssessmentChecklistItem } from "@/interfaces/assessments/IAssessmentDetails";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import {
  assessmentQuestionSubCateListCheckIsSelectedAll,
  assessmentQuestionSubCateListformatData,
} from "@/services/assessment";

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentQuestionSubCategoryList',
  props: {
  /** The order number of sub question category */
  orderNumber: {
    type: [Number, String],
    default: 1,
  },
  /** sub sub categories */
  subQuestion: {
    type: Array as () => any[],
    default: () => [],
  },
  selectedQuestions: {
    type: Array as () => any[],
    default: () => [],
  },
  answers: {
    type: Object as () => Record<string, any>,
    default: () => ({}),
  },
  overrideAnswer: {
    type: Object as () => Record<string, any>,
    default: () => ({}),
  },
  compensatingControlsAnswer: {
    type: Object as () => Record<string, any>,
    default: () => ({}),
  },
  question: {
    type: Object as PropType<IAssessmentChecklistItem>,
    required: true,
  },
  checklistId: {
    type: Number,
    default: 0,
  },
  isExclude: {
    type: Boolean,
    default: false,
  },
  hideComplete: {
    type: [Boolean, Object],
    default: false,
  },
},
  emits: [
  "update:selectedQuestions",
  "update:answers",
  "update:overrideAnswer",
  "update:compensatingControlsAnswer",
  "open-evidence-modal",
  "excludeItem",
  "clearFilter",
],
  setup(__props, { emit: emits }) {

const props = __props;





const subCategoriesData: any = ref([]);
const activeEvidenceData: any = ref({});
const onHover: Ref<boolean> = ref(false);
const questionFormat: Ref<IAssessmentChecklistItem> = ref({
  ...props.question,
} as IAssessmentChecklistItem);
let setTimeOutRef: any = null;

const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};

const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 150);
};

const prospectQuestionTypes: Ref<any> = computed(
  () => store.getters["Assessment/getAssessmentQuestionTypes"],
);

const isCheckComplete = computed(() => {
  if (questionFormat.value.checklistChildren) {
    return questionFormat.value.checklistChildren.every((child) => {
      if (child.checklistItemHasChildren)
        return child.checklistChildren?.every((el) => {
          return (
            el.itemCompleteValue !== undefined ||
            el.visibleState === assessmentQuestionVisibleState.no
          );
        });
      return (
        child.itemCompleteValue !== undefined ||
        child.visibleState === assessmentQuestionVisibleState.no
      );
    });
  }
  return questionFormat.value.checklistChildren?.every((child) => {
    return (
      child.itemCompleteValue !== undefined ||
      child.visibleState === assessmentQuestionVisibleState.no
    );
  });
});

const isCheckExposure = computed(() => {
  let isExposure: boolean | undefined = false;
  isExposure = questionFormat.value.checklistChildren?.some((child) => {
    return (
      Number(child.itemCompleteValue) >= 0 &&
      child.itemCompleteValue !== undefined
    );
  });

  if (isCheckComplete.value) {
    isExposure = !questionFormat.value.checklistChildren?.every((child) => {
      return child.itemCompleteValue === 100;
    });
  }

  return isExposure;
});

watch(
  () => props.selectedQuestions,
  () => {
    isChecked.value = assessmentQuestionSubCateListCheckIsSelectedAll(
      questionFormat.value,
      props.selectedQuestions,
    );
  },
);

const handleSelfCheck = (value, item) => {
  let allSelected: any[] = getListOrder(item);
  if (value) {
    emits("update:selectedQuestions", [
      ...props.selectedQuestions,
      ...allSelected.filter((item) => !props.selectedQuestions.includes(item)),
    ]);
  } else {
    const updatedList = props.selectedQuestions.filter(
      (item) => !allSelected.includes(item),
    );
    emits("update:selectedQuestions", updatedList);
  }
};

const handleSelfCheckChildren = (value, item, level) => {
  if (value) {
    addSelectedQuestion({ item, level });
  } else {
    removeSelectedQuestion({ item, level });
  }
};

const getListOrder = (item: any) => {
  let allSelected: any[] = [];
  allSelected.push(item?.checklistItemId);
  item?.checklistChildren?.map((item) => {
    allSelected.push(...getListOrder(item));
  });
  return allSelected;
};

const handleUpdateAnswer = (value: any, item: any, index: any) => {
  questionFormat.value.checklistChildren[
    index
  ].checklistItemComplianceTypeValue = value;
  setTimeout(() => {
    store.dispatch("Assessment/updateAnswer", {
      checklistId: item.checklistId,
      checklistItemId: item.checklistItemId,
      answer: value,
      type: ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_TYPE_VALUE,
    });
  }, 0);
};

const isChecked: Ref<boolean> = ref(
  assessmentQuestionSubCateListCheckIsSelectedAll(
    props.question,
    props.selectedQuestions,
  ),
);
const getParent = (item: any) => {
  let output: any;
  const loopParent = (data: any) => {
    if (output) {
      return output;
    }
    (data.checklistChildren || []).forEach((child: any) => {
      if (child?.checklistItemId === item?.checklistItemId) {
        output = data;
      } else {
        output = loopParent(child);
      }
    });
    return output;
  };
  output = loopParent(props.question);
  return output;
};

const addSelectedQuestion = (payload) => {
  const { item, level } = payload;
  let i = level;
  let parent = item;
  const arrParent: number[] = [];
  const parents: any = [];
  while (i > -1) {
    parent = getParent(parent);
    if (parent) {
      arrParent.push(parent.checklistItemId);
      parents.push(parent);
    }
    i -= 1;
  }

  const loopChild = (data: any) => {
    const output: any[] = [];
    (data.checklistChildren || []).forEach((child: any) => {
      output.push(child.checklistItemId);
      output.push(...loopChild(child));
    });
    return output;
  };
  const arrChild = loopChild(item);

  // add
  const output = Array.from(
    new Set([...props.selectedQuestions, item.checklistItemId, ...arrChild]),
  );
  parents.forEach((parent: any) => {
    const hasSelect = parent.checklistChildren.every((child: any) =>
      output.includes(child.checklistItemId),
    );
    if (hasSelect) {
      output.push(parent.checklistItemId);
    }
  });
  return emits("update:selectedQuestions", output);
};

const removeSelectedQuestion = (payload) => {
  const { item, level } = payload;
  let i = level;
  let parent = item;
  const arrParent: number[] = [];
  const parents: any = [];
  while (i > -1) {
    parent = getParent(parent);
    if (parent) {
      arrParent.push(parent.checklistItemId);
      parents.push(parent);
    }
    i -= 1;
  }

  const loopChild = (data: any) => {
    const output: any[] = [];
    (data.checklistChildren || []).forEach((child: any) => {
      output.push(child.checklistItemId);
      output.push(...loopChild(child));
    });
    return output;
  };
  const arrChild = loopChild(item);

  // prune
  const output = props.selectedQuestions.filter(
    (order) =>
      !(
        arrChild.includes(order) ||
        arrParent.includes(order) ||
        item.checklistItemId === order
      ),
  );
  return emits("update:selectedQuestions", output);
};

const addAnswer = (orderNumber, answer) => {
  emits("update:answers", { ...props.answers, [`${orderNumber}`]: answer });
};

const getDataOption = async () => {
  try {
    subCategoriesData.value = assessmentQuestionSubCateListformatData(
      questionFormat.value?.checklistChildren,
      props.checklistId,
      prospectQuestionTypes.value,
    );
    // checkStatus();
  } catch (error) {
    subCategoriesData.value = [];
  }
};

const processData = () => {
  subCategoriesData.value?.forEach((i) => {
    // Value for show answer type.
    i.answerType =
      i.checklistItemComplianceTypeId === "tf"
        ? assessmentQuestionAnswerType.radio
        : assessmentQuestionAnswerType.select;
    i.dropdownData =
      i.checklistItemComplianceTypeId === "tf"
        ? []
        : getDropdownData(i.checklistItemComplianceTypeId);

    // temp code to show suggestion
    // i.suggestion = i.answerType.toLowerCase() === "select" ? i.dropdownData[0].value : index % 2;
    i.visibleState = i.checklistItemIsExcluded || i.isMaster ? "No" : "Yes";
  });
};
watch(
  () => props.question,
  () => {
    getDataOption();
    processData();
    checkIsAllSelected();
  },
  { deep: true },
);
onMounted(() => {
  getDataOption();
});

const getDropdownData = (questionType: any) => {
  const data = prospectQuestionTypes.value.find(
    (item) => item.id === questionType,
  );
  return data?.complianceTypeValues || [];
};

const checkIsAllSelected = () => {
  const allQuestionOrderNumbers = props.subQuestion?.map(
    (item) => item.checklistItemId,
  );
  const isAllSelected = allQuestionOrderNumbers?.every((item) =>
    props.selectedQuestions.includes(item),
  );
  if (!isAllSelected) {
    isChecked.value = false;
  } else {
    isChecked.value = true;
  }
};

watch(
  () => props.question,
  () => {
    questionFormat.value = { ...props.question } as IAssessmentChecklistItem;
    getDataOption();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-bg-[transparent] tw-py-[20px] tw-px-[25px] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch`),
      onMouseover: onHoverIn,
      onMouseout: onHoverOut
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(CustomCheckBox, {
            "is-checked": isChecked.value,
            "onUpdate:isChecked": [
              _cache[0] || (_cache[0] = ($event: any) => ((isChecked).value = $event)),
              _cache[1] || (_cache[1] = (value) => handleSelfCheck(value, questionFormat.value))
            ],
            class: "tw-h-[20px] !tw-mb-0 tw-pl-[0px]",
            size: "20px",
            "bg-color": "#FFFFFF"
          }, null, 8, ["is-checked"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(__props.orderNumber) + ".", 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(questionFormat.value.checklistItemHeadingLabel ||
            questionFormat.value.checklistItemName ||
            ""), 1),
          (
            (questionFormat.value.checklistItemDescription ||
              questionFormat.value.checklistItemGuidance) &&
            onHover.value
          )
            ? (_openBlock(), _createBlock(ButtonShowDuplicateAssessment, {
                key: 0,
                "id-popover": 'popover-assessment-sub-category-list-' + __props.orderNumber,
                "custom-class": 'tw-w-[max-content] tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
                classes: `!tw-leading-none`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (questionFormat.value.checklistItemDescription)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
                      "app-menu-submenu-assessments-further-information-1",
                    )), 1),
                            _createVNode(CustomDescriptionContent, {
                              description: questionFormat.value.checklistItemDescription,
                              class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                            }, null, 8, ["description"])
                          ]))
                        : _createCommentVNode("", true),
                      (questionFormat.value.checklistItemGuidance)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                      "app-menu-submenu-assessments-guidance-1",
                    )), 1),
                            _createVNode(CustomDescriptionContent, {
                              description: questionFormat.value.checklistItemGuidance,
                              class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                            }, null, 8, ["description"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["id-popover"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (isCheckComplete.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-checklists-assessment-details-card-status-3",
              )), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(circularProgress, {
                    class: "tw-w-[12px] tw-h-[12px]",
                    percent: 100
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(getComponentUiText)(
                "app-menu-submenu-assessments-scanning-exposure-1",
              )), 1)
          ], 512), [
            [_vShow, isCheckExposure.value]
          ])
        ])
      ])
    ], 32),
    (
      questionFormat.value.checklistChildren &&
      questionFormat.value.checklistChildren.length === 0 &&
      __props.hideComplete
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(getComponentUiText)("app-assessment-input-empty-data-filter-1")), 1),
            _createElementVNode("p", {
              class: "tw-m-0 tw-text-[#387DFF] tw-text-[11px] tw-leading-[145%] tw-font-[500] tw-cursor-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('clearFilter')))
            }, _toDisplayString(_unref(getComponentUiText)("app-assessment-input-clear-filter-button-1")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subCategoriesData.value, (item, index, ___, _cached) => {
        const _memo = ([item, __props.selectedQuestions])
        if (_cached && _cached.key === item.checklistItemId && _isMemoSame(_cached, _memo)) return _cached
        const _item = (_openBlock(), _createBlock(AssessmentQuestion, {
          key: item.checklistItemId,
          index: index,
          "is-selected": __props.selectedQuestions.includes(item.checklistItemId),
          "prefilled-source": item.prefilledSource,
          "checklist-item-id": item.checklistItemId,
          "checklist-id": questionFormat.value.checklistItemId,
          "is-exclude": __props.isExclude,
          "checklist-item-is-excluded": item.checklistItemIsExcluded,
          "selected-questions": __props.selectedQuestions,
          "checklist-item": item,
          level: 0,
          "is-hover-show-note": false,
          onCheckedAll: _cache[3] || (_cache[3] = 
        (value, data, level) => handleSelfCheckChildren(value, data, level)
      ),
          onExclude: 
        (id) => emits('excludeItem', id, questionFormat.value.checklistItemId, item)
      ,
          onSelect: _cache[4] || (_cache[4] = (data) => addSelectedQuestion(data)),
          onUnselect: _cache[5] || (_cache[5] = (data) => removeSelectedQuestion(data)),
          onOnAnswer: _cache[6] || (_cache[6] = (data, answer) => addAnswer(data.checklistItemOrder, answer)),
          "onUpdate:answer": (value, item) => handleUpdateAnswer(value, item, index)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.checklistItemName) + _toDisplayString(item.subName ? ` | ${item.subName}` : ""), 1)
          ]),
          _: 2
        }, 1032, ["index", "is-selected", "prefilled-source", "checklist-item-id", "checklist-id", "is-exclude", "checklist-item-is-excluded", "selected-questions", "checklist-item", "onExclude", "onUpdate:answer"]))
        _item.memo = _memo
        return _item
      }, _cache, 7), 128))
    ])
  ], 64))
}
}

})